import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { HeaderMark, Button, Navbar, NavbarLink, NavbarSeparator } from "@repo/o37-ui";
import PartnerDashboard from "./components/PartnerDashboard";
import PartnerForecastingView from "./components/PartnerForecastingView";
import PartnerKanbanView from "./components/PartnerKanbanView";

type PartnerHubProps = {
  onLogout: () => void;
  partnerId?: string;
};

export default function PartnerHub({ onLogout, partnerId: propPartnerId }: PartnerHubProps) {
  const params = useParams<{ partnerId: string }>();
  const [activeTab, setActiveTab] = useState<'home' | 'kanban' | 'forecast'>('home');
  
  const getInitialPartnerId = () => {
    if (propPartnerId && propPartnerId !== "null" && propPartnerId !== "undefined") return propPartnerId;
    if (params.partnerId && params.partnerId !== "null" && params.partnerId !== "undefined") return params.partnerId;
    const stored = localStorage.getItem("partner_id");
    if (stored && stored !== "null" && stored !== "undefined") return stored;
    return undefined;
  };

  const [partnerId, setPartnerId] = useState<string | undefined>(getInitialPartnerId());
  const userEmail = localStorage.getItem("partner_email");

  // Sync partnerId if prop or params changes
  useEffect(() => {
    const id = getInitialPartnerId();
    if (id) setPartnerId(id);
  }, [propPartnerId, params.partnerId]);

  if (!partnerId) {
    return (
      <main className="min-h-screen bg-white text-black flex items-center justify-center">
        <div className="text-neutral-600">Loading Partner...</div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-white text-black">
      <HeaderMark />

      <Navbar
        leftContent={
          <>
            <NavbarLink active={activeTab === 'home'} onClick={() => setActiveTab('home')}>
              Home
            </NavbarLink>
            <NavbarSeparator />
            <NavbarLink active={activeTab === 'kanban'} onClick={() => setActiveTab('kanban')}>
              Kanban
            </NavbarLink>
            <NavbarSeparator />
            <NavbarLink active={activeTab === 'forecast'} onClick={() => setActiveTab('forecast')}>
              Forecast
            </NavbarLink>
          </>
        }
      >
        {userEmail && <span className="text-sm text-neutral-600">{userEmail}</span>}
        <Button
          variant="outline"
          onClick={onLogout}
          text="Logout"
        />
      </Navbar>

      {/* Tab Content */}
      {activeTab === 'home' && <PartnerDashboard partnerId={partnerId} />}
      {activeTab === 'kanban' && <PartnerKanbanView partnerId={partnerId} />}
      {activeTab === 'forecast' && <PartnerForecastingView partnerId={partnerId} />}

      {/* Footer */}
      <footer className="px-6 sm:px-12 mt-24 mb-10">
        <div className="max-w-5xl mx-auto flex items-center justify-between text-[12px] text-neutral-500">
          <div>By all means, accelerate.</div>
          <div>🏴</div>
        </div>
      </footer>
    </main>
  );
}
